import React from 'react';

const EventLabel = (props) => {
  const { races } = props;

  let eventLabel = '';

  const sportLabels = [
    ...new Set(races.map((race) => race.information.sportLabel)),
  ].filter((label) => !!label);

  if (sportLabels.length === 1) {
    // filters out duplicates, nulls and other
    const distanceLabels = [
      ...new Set(races.map((race) => race.information.distanceLabel)),
    ].filter((label) => !!label && label.toLowerCase() !== 'other');

    /** Trialthon Exception: List out all distance labels */
    // TODO: Dion Triathlon Logic -- behaviour design pending.
    // if (
    //   sportLabels[0].toLowerCase().includes('triathlon') &&
    //   distanceLabels.length > 0
    // ) {
    //   eventLabel = distanceLabels.join(' • ');
    // }
    if (distanceLabels.length === 1) {
      eventLabel = distanceLabels[0];
    } else {
      eventLabel = sportLabels[0];
    }
  } else if (sportLabels.length > 1) {
    eventLabel = 'Multi-Sport';
  } else {
    eventLabel = 'Event';
  }

  if (eventLabel.toLowerCase() === 'other') eventLabel = 'Event';

  return <span>{eventLabel}</span>;
};

export default EventLabel;
